import { useEffect, useState } from "react";
import FinishedQuiz from "../FinishedQuiz";
import QuestionData from "./McqJson.json";
import { toast } from "react-toastify";

const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const QuizContainer = ({
  compliments,
  setStart,
  setIsFinished,
  formatTime,
  isFinished,
  setSeconds,
  seconds,
  isStarted,
}) => {
  const [shuffledQuestions, setShuffledQuestions] = useState([]);
  const totalQuestions = shuffledQuestions?.length;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [score, setScore] = useState(0);
  const [progress, setProgress] = useState(0);
  const [showExplanation, setShowExplanation] = useState(false);
  const [tries, setTries] = useState(0);

  const currentQuestion = shuffledQuestions[currentIndex];

  useEffect(() => {
    const suffle = QuestionData?.slice(0, 10);
    setShuffledQuestions(shuffleArray(suffle));
  }, []);

  useEffect(() => {
    setProgress(((currentIndex + 1) / totalQuestions) * 100);
  }, [currentIndex, totalQuestions]);

  useEffect(() => {
    if (!selectedAnswer || !currentQuestion) return;

    const isCorrect = selectedAnswer === currentQuestion?.answer;

    if (isCorrect) {
      setShowExplanation(true);
      toast(
        compliments?.[Math.floor(Math.random() * compliments.length)] ||
          "Correct!",
        {
          className: "toast-correct d-flex justify-content-center",
          hideProgressBar: true,
          closeButton: false,
          onClose: () => handleNextQuestion(),
        }
      );
    } else {
      setTries(tries + 1);
      toast("Try again", {
        className: "toast-wrong d-flex justify-content-center",
        hideProgressBar: true,
        closeButton: false,
      });
    }
  }, [selectedAnswer]);

  const handleNextQuestion = () => {
    setScore((prev) =>
      tries === 1
        ? prev + 5
        : tries < 1
        ? prev + 10
        : tries === 2
        ? prev + 1
        : prev + 0
    );
    setTries(0);
    setSelectedAnswer("");
    setShowExplanation(false);
    setCurrentIndex((prev) => prev + 1);

    if (currentIndex + 1 >= totalQuestions) {
      setSeconds(0);
      setIsFinished(true);
    }
  };

  const handleReset = () => {
    setStart(false);
    setSeconds(160);
    setIsFinished(false);
    setCurrentIndex(0);
    setScore(0);
    setSelectedAnswer("");
    setShowExplanation(false);
  };

  // End screen
  if (currentIndex >= totalQuestions || isFinished) {
    return (
      <FinishedQuiz
        handleReset={handleReset}
        score={score}
        type={"mcq"}
        questionsCount={totalQuestions}
      />
    );
  }

  return (
    <div className="w-100 py-3 rounded-2" style={{ height: "100%" }}>
      {/* Top Header */}
      <div className="d-flex px-4 justify-content-between">
        <small>
          Question {currentIndex + 1} of {totalQuestions}
        </small>
        <p>Score: {score}</p>
      </div>

      {/* Progress Bar */}
      <div className="d-flex px-4 flex-column align-items-center gap-0">
        <div
          className="w-100 mb-4 rounded-3"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.1)" }}
        >
          <div
            className="rounded-3"
            style={{
              width: `${progress}%`,
              transition: "all 1s",
              padding: "5px",
              backgroundColor: "blue",
            }}
          />
        </div>

        <div className="d-flex align-items-center w-100 my-1 gap-3">
          <p className="fs-4  p-0 m-0">⏰</p>
          {isStarted && !isFinished && (
            <h4 className="p-0 m-0 rounded-3" style={{ color: "blue" }}>
              {seconds}s
            </h4>
          )}
        </div>
      </div>

      {/* Main Question Area */}
      <div
        className="px-4 d-flex flex-column align-items-center justify-content-between"
        style={{ height: "75%", overflow: "auto" }}
      >
        <h5 className="text-left w-100">
          {currentIndex + 1}. {currentQuestion?.question}
        </h5>

        <div className="bg-white rounded-4 shadow w-100 text-start">
          <div className="d-flex flex-column py-2 gap-2">
            {currentQuestion?.options?.map((option, index) => {
              const isCorrect = selectedAnswer === currentQuestion?.answer;

              return (
                <button
                  key={index}
                  onClick={() => setSelectedAnswer(option)}
                  disabled={selectedAnswer === currentQuestion?.answer}
                  className="rounded-3 p-2 text-start border-0 mx-3"
                  style={
                    selectedAnswer === option
                      ? isCorrect
                        ? {
                            backgroundColor: "rgb(58, 246, 58)",
                            color: "white",
                          }
                        : { backgroundColor: "red", color: "white" }
                      : { cursor: "pointer" }
                  }
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>

        {/* Explanation */}
        <div className="d-flex w-100 justify-content-end mt-2">
          <em
            style={{
              transitionDuration: "300ms",
            }}
            className={`px-1 rounded-2 p-2  ${
              showExplanation ? "opacity-100  " : "opacity-0"
            }`}
          >
            {currentQuestion?.description}
          </em>
        </div>
      </div>
    </div>
  );
};

export default QuizContainer;
